import React, { Component } from 'react';
import { array, bool, shape } from 'prop-types';
import { connect } from 'react-redux';
import { LABELS } from 'src/util/PrioritizeUtil'
import { LabeledContainer } from 'src/components/layout'
import { Factor } from 'src/components/Factor'

class ExampleFactors extends Component {
  state = { isHintOpen: true }
  render() {
    const { hide, collection } = this.props
    const { isHintOpen } = this.state
    const defaultQuestions = []
    const questions = collection && collection.questions ? collection.questions : defaultQuestions

    return (
      (isHintOpen && <div className='create-step2'>
        {hide && <label className="create-step2__hide" onClick={() => this.setState({ isHintOpen: false })}>Hide This</label>}
        <LabeledContainer title={LABELS.eval_factors_rating_guide} >
          <div className="factors_container" >
            {questions.length ? questions.map((factorInfo, idx) =>
              <Factor
                readOnly
                key={factorInfo.id}
                factor={factorInfo}
                onSaveClick={this.onFactorSave}
              />
            ) : <div>Loading...</div>}
          </div>
        </LabeledContainer>
      </div>)
    )
  }
}

ExampleFactors.propTypes = {
  hide: bool,
  collection: shape({ questions: array }),
};

ExampleFactors.defaultProps = {
  hide: false,
  collection: {},
};

const mapStateToProps = ({ prioritize }) => {
  return {
    collection: prioritize.collection
  };
};

export default connect(mapStateToProps, {})(ExampleFactors);
